import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Divider, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import request from '../utils/request';
import Tracker from './tracker';
import Summary from './summary';
import Support from './support';
import Details from './details';
import { ContentWrapper } from './css';

const OrderTracking = ({ location: { search } }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    orderTracking: { invalidToken }
  } = localizedStrings;

  const { token } = queryString.parse(search);

  const [orderData, setOrderData] = useState();
  const [error, setError] = useState(false);

  useEffect(() => {
    document.getElementById('footer').remove();
    request
      .get(`/orders/order-tracking/?token=${token}`)
      .then(resp => {
        setOrderData(resp.data);
      })
      .catch(() => {
        setError(true);
      });
  }, []);

  return (
    <>
      {error && (
        <Typography heading="h2" variant={{ size: 'h2' }} block>
          {invalidToken}
        </Typography>
      )}
      {!error && orderData && (
        <>
          <ContentWrapper>
            <Details orderData={orderData} />
            <Tracker orderData={orderData} />
            <Divider space={3} variant={{ inverse: true }} />
            <Summary orderData={orderData} />
          </ContentWrapper>
          <Support />
        </>
      )}
    </>
  );
};

OrderTracking.propTypes = {
  location: PropTypes.objectOf(PropTypes.string).isRequired
};

export default OrderTracking;
